import cjPontanegraApi from '../apis/cjPontanegraApi';

export const deleteAdvertisementCategoryAvatarsService = async (
  categoryId: string,
): Promise<void> => {
  await cjPontanegraApi.delete(
    `/avatars/announcement-categories/${categoryId}`,
  );
};
